<template>
  <v-card outlined class="pago-card">
    <div class="flexcontainer pa-2">
      <span class="flexitem">
        <span class="r-box r-title2">N° Comprobante</span>
        <span class="r-box r-text">{{ pago.numComprobante || '—' }}</span>
      </span>
      <span class="flexitem" v-if="pago.nroFactura">
        <span class="r-box r-title2">N° Factura</span>
        <span class="r-box r-text">{{ pago.nroFactura }}</span>
      </span>
      <span class="flexitem">
        <span class="r-box r-title2">Fecha de Pago</span>
        <span class="r-box r-text">{{ formatFecha(pago.fechaPago) }}</span>
      </span>
      <span class="flexitem">
        <span class="r-box r-title2">Señor(a) Depositante</span>
        <span class="r-box r-text">
          {{ pago.nombreDepositante || '—' }}
          {{ pago.numDocDepositante ? ' - ' + pago.numDocDepositante : '' }}
        </span>
      </span>
    </div>

    <div class="table-container mx-2 mb-2">
      <table class="item-table">
        <thead>
          <tr>
            <th class="item-th text-center" style="width:2em">#</th>
            <th class="item-th text-center">Concepto</th>
            <th class="item-th text-center" style="width:5em">N° Cuota</th>
            <th class="item-th text-center" style="width:5em">Cantidad</th>
            <th class="item-th text-center" style="width:6em">Monto</th>
            <th class="item-th text-center" style="width:6em">Subtotal</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in pago.detalle" :key="item.id" class="item-tr">
            <td class="item-td text-center">{{ index + 1 }}</td>
            <td class="item-td">{{ item.concepto || '—' }}</td>
            <td class="item-td text-center">{{ item.nroCuota ?? '—' }}</td>
            <td class="item-td text-center">{{ item.cantidad ?? 1 }}</td>
            <td class="item-td text-center">{{ fixeddecimal(item.monto) }}</td>
            <td class="item-td text-center">{{ fixeddecimal(item.subTotal ?? item.monto) }}</td>
          </tr>
          <tr class="item-tr">
            <td colspan="5" class="text-right item-td">Total</td>
            <td class="item-td text-center total-cell">{{ fixeddecimal(pago.total) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="$slots.acciones" class="pago-card-actions px-2 pb-2">
      <slot name="acciones" />
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'PagoInscripcionCard',
  props: {
    pago: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatFecha(fecha) {
      if (!fecha) return '—';
      const [year, month, day] = `${fecha}`.slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },
    fixeddecimal(valor) {
      const numero = Number(valor);
      return Number.isFinite(numero) ? numero.toFixed(2) : '0.00';
    },
  },
};
</script>

<style scoped>
.pago-card {
  border-radius: 8px;
}

.flexcontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
}

.flexitem {
  margin-right: 0.3em;
  margin-left: 0.3em;
  margin-bottom: 0.4em;
  display: inline-flex;
  vertical-align: middle;
  justify-content: space-around;
}

.r-box {
  font-size: 0.75em;
  line-height: 1.5;
  padding: 0.2em 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.r-title2 {
  font-weight: bold;
  color: #305077;
  background-color: rgba(237, 252, 255, 0.705);
  border: solid 1px #4d84c7c7;
  border-right: none;
  border-radius: 0.4em 0 0 0.4em;
}

.r-text {
  background-color: rgb(253, 253, 253);
  border: solid 1px #4d84c7c7;
  border-left: none;
  border-radius: 0 0.4em 0.4em 0;
}

.table-container {
  border: 1px solid #dce6f0;
  border-radius: 8px;
  overflow-x: auto;
}

.item-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 11px;
}

.item-td,
.item-th {
  border: 1px solid silver;
  padding: 6px 8px;
}

.item-th {
  background: #f6f8fb;
  color: #305077;
  font-weight: 700;
}

.total-cell {
  font-weight: 700;
  color: #1e293b;
}
</style>
